import React from 'react';
import { BarChart } from '../BarChart';
import { Histogram } from '../Histogram';
import { LineChart } from '../LineChart';
import { ScatterPlot } from '../ScatterPlot';
import { SummaryCard } from '../SummaryCard';
import { Table } from '../Table';

export const DASHBOARD_COLS = { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 };
export const DASHBOARD_COLS_BREAKPOINTS = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 };

export const SUPPORTED_CHART_TYPES = [
  'bar_chart',
  'line_chart',
  'scatter_plot',
  'table',
  'summary_card',
  'histogram',
  'combo_chart',
] as const;
export type SupportedChartType = (typeof SUPPORTED_CHART_TYPES)[number];

export interface ChartComponentConfig {
  component: React.ComponentType<any>;
  supportsStacking?: boolean;
  supportsGrouping?: boolean;
}

export const CHART_REGISTRY: Record<SupportedChartType, ChartComponentConfig> = {
  bar_chart: {
    component: BarChart,
    supportsStacking: true,
    supportsGrouping: true,
  },
  combo_chart: {
    // Same renderer as line_chart; combo passes seriesStyles + rangeBands via DashboardLayout.
    component: LineChart,
    supportsStacking: false,
    // Group-by is disabled for combo charts at the form level; keep false here for symmetry.
    supportsGrouping: false,
  },
  histogram: {
    component: Histogram,
    supportsStacking: false,
    supportsGrouping: false,
  },
  line_chart: {
    component: LineChart,
    supportsStacking: false,
    supportsGrouping: true,
  },
  scatter_plot: {
    component: ScatterPlot,
    supportsStacking: false,
    supportsGrouping: false,
  },
  summary_card: {
    component: SummaryCard,
    supportsStacking: false,
    supportsGrouping: false,
  },
  table: {
    component: Table,
    supportsStacking: false,
    supportsGrouping: false,
  },
} as const;

export const ERROR_MESSAGES = {
  UNSUPPORTED_CHART_TYPE: {
    title: 'Unsupported Chart Type',
    getMessage: (chartType: string) => `Chart type "${chartType}" is not yet supported.`,
  },
  NO_DATA_AVAILABLE: {
    title: 'No Data Available',
    message: 'This chart has no data to display.',
  },
  CONFIGURATION_REQUIRED: {
    title: 'Configuration Required',
    message: 'This chart needs field configuration to display properly.',
  },
  CHART_CONFIGURATION_ERROR: {
    title: 'Chart Configuration Error',
    message: 'Unable to build chart with the provided field configuration.',
  },
} as const;

export const DEFAULT_VISUALIZATION_HEIGHT = '200px';
